module.exports = __webpack_public_path__ + "img/img24.9d5a18be.png";